import { render } from "./IconArrowLeft3sticks.vue?vue&type=template&id=11e44e3b"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__